import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MessageService } from 'primeng/api';
import { PropertyService } from '../../properties/service/property.service';

@Component({
  selector: 'app-create-amenity-category',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
  ],
  templateUrl: './create-amenity-category.component.html',
  styleUrls: ['./create-amenity-category.component.scss'],
  providers: [MessageService],
})
export class CreateAmenityCategoryComponent {
  amenityCategoryForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private messageService: MessageService,
    private propertyService: PropertyService,
  ) {
    this.amenityCategoryForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
    });
  }

  saveAmenityCategory() {
    if (this.amenityCategoryForm.valid) {
      const amenityCategoryData = this.amenityCategoryForm.value;

      this.propertyService.saveAmenityCategory(amenityCategoryData).subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Amenity category created successfully!',
          });
          this.router.navigate(['/amenity-categories']);
        },
        error: (err) => {
          console.error('Error creating amenity category:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to create amenity category.',
          });
        },
      });
    }
  }
}
